export default __webpack_public_path__ + "77151e773f7fd430fa2e92fe05520ca3.svg";